import styled from "styled-components";

export const WrapperButton = styled.div`
  margin-top: 1rem;
`;
